export const GAMESTATE = '[GAMESTATE]'
export const RESET_GAME_STATE = `${GAMESTATE} Reset Game State`
export const ADD_PAGE_STATE = `${GAMESTATE} Add current page to Game State`
export const SET_BATTLE_RESULT_STATE = `${GAMESTATE} Set current battle result in Game State`

export const resetGameState = () => ({
    type: RESET_GAME_STATE,
    payload: {},
})

export const addPageState = page => ({
    type: ADD_PAGE_STATE,
    payload: {
        page,
    },
    meta: {
        persisted: 'gameState',
    },
})

export const setBattleResultState = battleResult => ({
    type: SET_BATTLE_RESULT_STATE,
    payload: {
        battleResult,
    },
    meta: {
        battleStage: battleResult,
        persisted: 'gameState',
    },
})

